import type { ShoppingCartItemGroupData } from '../../../../app/data/model';
import Image from '../../../../app/shared/components/Image/Image';
import { CartItemDetails } from '../../../cart/CartItem/CartItemDetails/CartItemDetails';
import type { AddedToCartItemTranslation, CartItemPreviewTranslation } from '../../../localization/SiteTranslation';
import { CartItemSubtotal } from '../CartItemSubtotal/CartItemSubtotal';
import css from './AddedToCartItemGroup.css';

interface AddedToCartItemGroupProps {
  item: ShoppingCartItemGroupData;
  translation: AddedToCartItemTranslation;
}

export const AddedToCartItemGroup = ({ item, translation }: AddedToCartItemGroupProps) => {
  return (
    <div>
      <p className={css.shoppingCartProductName}>{item.name}</p>
      <CartItemPreview item={item} translation={translation.cartItemPreview} />
      <CartItemSubtotal totalPrice={item.salePrice} translation={translation.cartItemSubtotal} />
    </div>
  );
};

interface CartItemPreviewProps {
  item: ShoppingCartItemGroupData;
  translation: CartItemPreviewTranslation;
}

const CartItemPreview = ({ item, translation }: CartItemPreviewProps) => {
  return (
    <div className={css.shoppingCartDetails}>
      <Image
        className={css.shoppingCartDetailsImage}
        src={item.imageUrl}
        width={100}
        height={150}
        sharpeningFactor={2}
        scalingMode="fit"
      />
      <CartItemDetails
        code={item.modularCode}
        quantity={item.quantity}
        listPrice={item.listPrice}
        salePrice={item.salePrice}
        className={css.shoppingCartDetailsItem}
        propertyClassNames={{
          labelClassName: css.shoppingCartDetailsConfigLabel,
          valueClassName: css.shoppingCartDetailsConfigValue,
        }}
        translation={translation.cartItemDetails}
      />
    </div>
  );
};
